var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 16C39.1 16 37.48 18.88 38.14 21.02L31.04 28.14C30.44 27.96 29.56 27.96 28.96 28.14L23.86 23.04C24.54 20.9 22.92 18 20 18C17.1 18 15.46 20.88 16.14 23.04L7.02 32.14C4.88 31.48 2 33.1 2 36C2 38.2 3.8 40 6 40C8.9 40 10.52 37.12 9.86 34.98L18.96 25.86C19.56 26.04 20.44 26.04 21.04 25.86L26.14 30.96C25.46 33.1 27.08 36 30 36C32.9 36 34.54 33.12 33.86 30.96L40.98 23.86C43.12 24.52 46 22.9 46 20C46 17.8 44.2 16 42 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18L31.88 13.86L36 12L31.88 10.14L30 6L28.16 10.14L24 12L28.16 13.86L30 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22L8 18L12 17L8 16L7 12L6 16L2 17L6 18L7 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphViewIcon);
export default __webpack_public_path__ + "static/media/graphViewIcon.2d19950b68587c483c29268afc19d391.svg";
export { ForwardRef as ReactComponent };